export class SubscriptionsConfig {
	public static readonly keys = {
		MYSUBS_DOCS_TAB_LABEL_KEY: 'MYSUBS_DOCS_TAB_LABEL',
		MYSUBS_DOCS_TAB_LABEL_DEFAULT: 'Documents', // It only will be used if MYSUBS_DOCS_TAB_LABEL_KEY is not givven in DCR
		MYSUBS_DOCS_NO_RECORD_MESSAGE_KEY: 'MYSUBS_DOCS_NO_RECORD_MESSAGE',

		MYSUBS_INSIGHTS_TAB_LABEL_KEY: 'MYSUBS_INSIGHTS_TAB_LABEL',
		MYSUBS_INSIGHTS_TAB_LABEL_DEFAULT: 'Insights', // It only will be used if MYSUBS_INSIGHTS_TAB_LABEL_KEY is not givven in DCR
		MYSUBS_INSIGHTS_NO_RECORD_MESSAGE_KEY: 'MYSUBS_INSIGHTS_NO_RECORD_MESSAGE'
	};

	public static readonly title = 'Your subscriptions';
	public static readonly title_bfa = 'My subscriptions';
	public static readonly MAX_RECORDS_AT_A_TIME = 8;
	public static readonly BUTTON_LABEL = 'Manage';
	public static readonly SUB_UNSUB_FLAG = 'subscribe_record_flag';

	public static readonly TAB_LABEL_KEYS = [
		SubscriptionsConfig.keys.MYSUBS_DOCS_TAB_LABEL_KEY,
		SubscriptionsConfig.keys.MYSUBS_INSIGHTS_TAB_LABEL_KEY
	];

	public static readonly INSIGHTS_MANAGE_ENDPOINT = 'manageInsightsUrl';
	public static readonly SUBS_REPORTS_MANAGE_ENDPOINT = 'unsubscribeUrl';
}
